import React from "react";

class IconSlack extends React.Component {
    render() {
        return (
            <svg
                className="icon--slack"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g fill="currentColor" fillRule="nonzero">
                        <path d="M15.5852343,1.50271885 C15.2579616,0.411809757 14.0579616,-0.242735697 12.8579616,0.0845370302 C11.7670525,0.411809757 11.1125071,1.61180976 11.4397798,2.81180976 L17.0034162,19.8299916 C17.3306889,20.9209007 18.5306889,21.4663552 19.621598,21.1390825 C20.7125071,20.8118098 21.4761434,19.6118098 21.0397798,18.5209007 C21.0397798,18.4118098 15.5852343,1.50271885 15.5852343,1.50271885" />
                        <path d="M6.96705253,4.22999158 C6.6397798,3.13908248 5.4397798,2.48453703 4.2397798,2.81180976 C3.14887071,3.13908248 2.49432526,4.33908248 2.82159798,5.53908248 L8.38523435,22.5572643 C8.71250707,23.6481734 9.91250707,24.1936279 11.0034162,23.8663552 C12.0943253,23.5390825 12.8579616,22.3390825 12.421598,21.2481734 C12.5306889,21.2481734 6.96705253,4.22999158 6.96705253,4.22999158" />
                        <path d="M22.4579616,15.5754461 C23.5488707,15.2481734 24.2034162,14.0481734 23.8761434,12.8481734 C23.5488707,11.7572643 22.3488707,11.1027188 21.1488707,11.4299916 L4.13068889,16.9936279 C3.0397798,17.3209007 2.49432526,18.5209007 2.82159798,19.6118098 C3.14887071,20.7027188 4.34887071,21.4663552 5.4397798,21.0299916 C5.54887071,21.0299916 22.4579616,15.5754461 22.4579616,15.5754461" />
                        <path d="M19.7306889,6.9572643 C20.821598,6.62999158 21.4761434,5.42999158 21.1488707,4.22999158 C20.821598,3.13908248 19.621598,2.48453703 18.421598,2.81180976 L1.40341616,8.37544612 C0.312507074,8.70271885 -0.232947472,9.90271885 0.0943252555,10.9936279 C0.421597983,12.084537 1.62159798,12.8481734 2.71250707,12.4118098 C2.71250707,12.5209007 19.7306889,6.9572643 19.7306889,6.9572643" />
                    </g>
                </g>
            </svg>
        );
    }
}

export default IconSlack;



// WEBPACK FOOTER //
// ./src/components/icons/IconSlack.jsx